import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import NavbarMiniCell from './NavbarMiniCell';

export interface ISectionDataProps {
  id: number;
  title: string;
  url: string;
  src: string;
  boldIcon: string;
  permissions?: string[] | string;
}

interface IShortcutsSectionProps {
  sectionName: string;
  item: ISectionDataProps;
  hidden: boolean;
  setHidden: React.Dispatch<React.SetStateAction<boolean>>;
}

function ShortcutsSection({ sectionName, item, hidden, setHidden }: IShortcutsSectionProps) {
  const location = useLocation();

  return (
    <Box sx={{ backgroundColor: '#ffff' }}>
      <Box key={item.id} display="flex" justifyContent="center" sx={{ backgroundColor: '#ffff' }}>
        <NavbarMiniCell
          title={sectionName}
          url={item.url}
          src={item.src}
          boldIcon={item.boldIcon}
          isSelected={
            (location.pathname.split('/')[1] === item.url.split('/')[1] && hidden) ||
            (!hidden && item.url === '')
          }
          hidden={hidden}
          setHidden={setHidden}
        />
      </Box>
    </Box>
  );
}

export default ShortcutsSection;
